import React, { Component } from 'react';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';

import Isvg from 'react-inlinesvg';
import { Button, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Checkbox from './checkbox';



class MultiSelectModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedValues: []
        };
    }

    handleChange = () => {
        this.props?.onChange?.(this.state.selectedValues?.length ? this.state.selectedValues : null);
    }

    componentDidMount() {
        const value = typeof this.props.value === 'object' && this.props.value?.length ? this.props.value : [];
        this.setState({ selectedValues: value });
    }

    render() {
        const values = this.props.values ?? [];
        const error = this.props.error ?? null;

        return (
            <div className='multi-select-modal-field-wrap'>
                <Button
                    onClick={() => this.setState({
                        modal: true
                    })}
                    color="primary"
                    className='multi-select-modal-field-btn'
                >
                    {this.props?.label ?? 'Select'.translate(this.props.lang)}
                </Button>
                {
                    error ? <div className='error-message'>{error}</div> : null
                }

                {
                    this.state.modal ?
                        <Modal
                            size="lg"
                            isOpen={this.state.modal}
                            centered
                            toggle={() => this.setState({ modal: !this.state.modal })}
                        >
                            <ModalHeader
                                toggle={() => this.setState({ modal: !this.state.modal })}
                                close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ modal: !this.state.modal })}><Isvg src={xIcon} /></button>}
                            >
                                {this.props?.label ?? 'Select'.translate(this.props.lang)}
                            </ModalHeader>

                            <ModalBody className="multi-select-modal-field-modal-body">
                                <div className='select-unselect-all-wrap'>
                                    <Button
                                        color='primary'
                                        onClick={() => {
                                            if (values.length) {
                                                let selectedValues = [];
                                                for (let i = 0; i < values.length; i++) {
                                                    selectedValues.push(values[i].value)
                                                }
                                                this.setState({ selectedValues }, () => {
                                                    this.handleChange();
                                                })
                                            }
                                        }}
                                    >{'Select all'.translate(this.props.lang)}
                                    </Button>
                                    <Button
                                        color='primary'
                                        onClick={() => {
                                            this.setState({ selectedValues: [] }, () => {
                                                this.handleChange();
                                            })
                                        }}
                                    >
                                        {'Unselect all'.translate(this.props.lang)}
                                    </Button>
                                </div>
                                <FormGroup className="form-group-checkbox">
                                    {
                                        values && values.map((item, idx) => {
                                            return (
                                                <Checkbox
                                                    checked={this.state.selectedValues.filter(el => el === item.value).length}
                                                    onChange={(e) => {
                                                        let selectedValues = this.state.selectedValues;
                                                        if (e.target.checked) {
                                                            if (selectedValues.filter(el => el == item.value).length == 0) {
                                                                selectedValues.push(item.value)
                                                            }
                                                        } else {
                                                            let index = selectedValues.indexOf(item.value);
                                                            if (index > -1) {
                                                                selectedValues.splice(index, 1);
                                                            }
                                                        }

                                                        this.setState({ selectedValues }, () => {
                                                            this.handleChange();
                                                        })


                                                    }}
                                                    label={item.name}
                                                />
                                            )
                                        })
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button color='primary' onClick={() => this.setState({ modal: false })}>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
            </div>
        );
    }
}

export default MultiSelectModal;